import React from 'react'
import { Container, ContainerInformation } from './styles'
import { ModalHeader } from '../../ModalComponents/ModalHeader'
import { ModalInformations } from '../../ModalComponents/ModalInformations'
import { ModalLongInformations } from '../../ModalComponents/ModalLongInformations'
import { IMedicalNote } from '~/interfaces'
import { replaceStringDashesBy, transformDate } from '~/utils'

interface MedicalNoteDetailsContentProps {
  medicalNoteData: IMedicalNote
}

export const MedicalNoteDetailsContent = ({ medicalNoteData }: MedicalNoteDetailsContentProps): JSX.Element => {
  return (
    <Container>
      <ModalHeader title={medicalNoteData.title} datetime={medicalNoteData?.creationDate} />

      <hr />

      <ContainerInformation>
        {medicalNoteData.medicalNoteRecords?.map(({ recordId, content, date, responsiblePhysician }, index) => (
          <React.Fragment key={recordId}>
            <ModalLongInformations valueHTML={content} />
            <ModalInformations label="Data" value={transformDate({ date, withHourAndMinute: true })} />
            <ModalInformations label="Autor" value={`${responsiblePhysician.name}`} />
            <ModalInformations
              label="Conselho"
              value={`${responsiblePhysician.boardName}: ${responsiblePhysician.boardRegistry} / ${responsiblePhysician.federativeUnit}`}
            />
            <ModalInformations
              label="Telefone(s)"
              value={replaceStringDashesBy(', ')(responsiblePhysician.phoneContact)}
            />
            <ModalInformations
              label="E-mail(s)"
              value={replaceStringDashesBy(', ')(responsiblePhysician?.emailContact?.join(', '))}
            />
            {index !== medicalNoteData.medicalNoteRecords?.length - 1 ? <hr /> : null}
          </React.Fragment>
        ))}
      </ContainerInformation>
    </Container>
  )
}
